<template>
    <div class="content-body" style="padding-top: 6rem">
        <div class="container-fluid">
            <!-- Button Add -->
            <router-link :to="{ name: 'Tambah Paper' }" class="btn btn-primary mb-4">Tambah</router-link>

            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="form-group">
                                <h4 class="card-title mb-3">Cari Data {{ currentRouteName }}</h4>
                                <p class="text-muted">Total Produk: {{ filteredCount }}</p>
                                <!-- Search bar, Filter button, and Sort button -->
                                <div class="d-flex align-items-center mb-4">
                                    <!-- Search Input -->
                                    <input v-model="searchQuery" @input="handleSearch" class="form-control mr-3" placeholder="Search..." style="border-radius: 8px; width: 250px" />

                                    <!-- Filter Dropdown -->
                                    <div class="dropdown mr-3">
                                        <button
                                            class="btn btn-outline-primary"
                                            type="button"
                                            id="filterDropdown"
                                            data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                            style="border-radius: 8px; display: flex; align-items: center; gap: 5px">
                                            <i class="fa fa-filter"></i>
                                            Filter
                                        </button>
                                        <div class="dropdown-menu p-3" aria-labelledby="filterDropdown" style="width: 300px">
                                            <h6 class="dropdown-header">Add Filter</h6>
                                            <div class="d-flex flex-wrap">
                                                <!-- Status Filter -->
                                                <div class="filter-option" style="width: 100%" @click.stop>
                                                    <label for="statusFilter" class="filter-label">Status</label>
                                                    <select v-model="selectedStatus" id="statusFilter" class="form-control">
                                                        <option value="">All</option>
                                                        <option value="publish">Publish</option>
                                                        <option value="unpublish">Unpublish</option>
                                                    </select>
                                                </div>

                                                <!-- Sort Order Filter -->
                                                <div class="filter-option" style="width: 100%" @click.stop>
                                                    <label for="sortFilter" class="filter-label">Sort</label>
                                                    <select v-model="sortOrder" id="sortFilter" class="form-control">
                                                        <option value="desc">Descending</option>
                                                        <option value="asc">Ascending</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Reset Button -->
                                    <button @click="resetFilters" class="btn btn-link">Reset</button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div v-if="isLoading" class="text-center my-4">
                                <div class="spinner-border text-primary" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Nama Produk</th>
                                            <th>Brand</th>
                                            <th>Kategori</th>
                                            <th>Thumbnail</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="!paginatedData.length" class="text-center">
                                            <td colspan="7">No Data</td>
                                        </tr>
                                        <tr v-for="(item, index) in paginatedData" :key="item.id">
                                            <td>{{ (currentPage - 1) * perPage + index + 1 }}</td>
                                            <td>{{ truncateText(item.nm_produk || "", 50) }}</td>
                                            <td>{{ item.nm_brands }}</td>
                                            <td>{{ item.kategori ? item.kategori.judul : "-" }}</td>
                                            <td>
                                                <img :src="getImageUrl(item)" alt="Preview" style="width: 120px; height: 70px; object-fit: cover; border-radius: 10px" />
                                            </td>
                                            <td>{{ item.is_publish ? "Publish" : "No" }}</td>
                                            <td class="flex">
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <router-link :to="{ name: 'Edit Paper', params: { id: item.id } }" class="btn btn-primary btn-rounded btn-xxs mr-1 mb-1">
                                                        <i class="fa fa-pencil color-muted"></i>
                                                    </router-link>
                                                    <button type="button" class="btn btn-dark btn-rounded btn-xxs mr-1 mb-1" @click="deletePaper(item.id)">
                                                        <i class="fa fa-trash color-muted"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!-- Pagination -->
                            <nav>
                                <ul class="pagination justify-content-end mt-3">
                                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                        <a class="page-link" href="javascript:void(0)" @click="prevPage">Previous</a>
                                    </li>
                                    <li
                                        v-for="(page, index) in visiblePages"
                                        :key="index"
                                        class="page-item"
                                        :class="{
                                            active: page === currentPage,
                                            disabled: page === '...',
                                        }">
                                        <a class="page-link" href="javascript:void(0)" @click="page !== '...' && goToPage(page)">
                                            {{ page }}
                                        </a>
                                    </li>
                                    <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                                        <a class="page-link" href="javascript:void(0)" @click="nextPage">Next</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import Swal from "sweetalert2";
import axiosInstance from "../../axios";
import defaultURL from "@/config";

export default {
    name: "Paper",

    setup() {
        const store = useStore();
        const router = useRoute();
        const currentRouteName = computed(() => router.name);
        const Paper = ref([]);
        const isLoading = ref(false);

        const currentPage = ref(1);
        const perPage = 10;
        const searchQuery = ref("");
        const totalItems = ref(0);
        const selectedStatus = ref("");
        const sortOrder = ref("desc");

        const resetFilters = () => {
            searchQuery.value = "";
            selectedStatus.value = "";
            sortOrder.value = "desc";
            handleSearch();
        };

        const filteredCount = computed(() => filteredData.value.length);

        const getImageUrl = (item) => {
            if (item && item.image) {
                return `${defaultURL}/images/paper/${item.image}`;
            }
            return "";
        };

        const isAuthenticated = computed(() => store.getters.isAuthenticated);
        const token = computed(() => store.getters.token);
        const tokenExpiry = computed(() => store.getters.tokenExpiry);

        if (!token.value || !tokenExpiry.value || new Date() > new Date(tokenExpiry.value) || !isAuthenticated.value) {
            Swal.fire({
                title: "Error",
                text: `Session expired or invalid`,
                icon: "error",
                confirmButtonText: "OK",
            }).then(() => {
                store.dispatch("setAuth", false);
                store.dispatch("setToken", { token: null, expiry: null });
                localStorage.clear();
                window.location.href = "/";
            });
            return;
        }

        const fetchData = async () => {
            isLoading.value = true;
            try {
                const getData = await axiosInstance.get(`/paper`, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token.value}`,
                    },
                });

                if (getData.status === 200) {
                    const data = await getData.data;
                    if (data.code === 200) {
                        Paper.value = data.data;
                        totalItems.value = data.data.length;
                    }
                } else {
                    Swal.fire({
                        title: "Error",
                        text: `Error: ${getData.data.message}`,
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                }
            } catch (error) {
                await Swal.fire({
                    title: "Error",
                    text: `Error: ${error.message}`,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            } finally {
                isLoading.value = false;
            }
        };

        const filteredData = computed(() => {
            return Paper.value
                .filter((item) => {
                    const matchStatus = !selectedStatus.value || (selectedStatus.value === "publish" && item.is_publish) || (selectedStatus.value === "unpublish" && !item.is_publish);
                    const matchSearch = (item.nm_produk || "").toLowerCase().includes(searchQuery.value.toLowerCase());
                    return matchStatus && matchSearch;
                })
                .sort((a, b) => {
                    if (sortOrder.value === "asc") return new Date(a.created_date) - new Date(b.created_date);
                    return new Date(b.created_date) - new Date(a.created_date);
                });
        });

        const paginatedData = computed(() => {
            const start = (currentPage.value - 1) * perPage;
            const end = start + perPage;
            return filteredData.value.slice(start, end);
        });

        const visiblePages = computed(() => {
            const total = totalPages.value;
            const current = currentPage.value;
            const delta = 1;
            const pages = [];

            if (total <= 7) {
                for (let i = 1; i <= total; i++) pages.push(i);
                return pages;
            }

            pages.push(1);
            if (current > 3) pages.push("...");

            const start = Math.max(2, current - delta);
            const end = Math.min(total - 1, current + delta);
            for (let i = start; i <= end; i++) pages.push(i);

            if (current < total - 2) pages.push("...");
            pages.push(total);

            return pages;
        });

        const totalPages = computed(() => {
            return Math.ceil(filteredData.value.length / perPage);
        });

        const handleSearch = () => {
            currentPage.value = 1;
        };

        const goToPage = (page) => {
            if (page >= 1 && page <= totalPages.value) {
                currentPage.value = page;
            }
        };

        const nextPage = () => {
            if (currentPage.value < totalPages.value) currentPage.value++;
        };

        const prevPage = () => {
            if (currentPage.value > 1) currentPage.value--;
        };

        const truncateText = (text, length) => {
            if (!text) return "";
            return text.length > length ? text.slice(0, length) + "..." : text;
        };

        const deletePaper = async (id) => {
            try {
                const confirmation = await Swal.fire({
                    title: "Are you sure?",
                    text: "You won't be able to revert this!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete it!",
                    cancelButtonText: "No, cancel!",
                });

                if (confirmation.isConfirmed) {
                    const response = await axiosInstance.delete(`/paper/${id}`, {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token.value}`,
                        },
                    });

                    if (response.status === 200) {
                        Swal.fire("Deleted!", "Your record has been deleted.", "success");
                        Paper.value = Paper.value.filter((item) => item.id !== id);
                    } else {
                        Swal.fire("Error!", "There was an issue deleting the record.", "error");
                    }
                }
            } catch (error) {
                Swal.fire("Error!", `Error: ${error.message}`, "error");
            }
        };

        onMounted(() => {
            fetchData();
        });

        return {
            currentRouteName,
            Paper,
            fetchData,
            searchQuery,
            handleSearch,
            paginatedData,
            visiblePages,
            currentPage,
            totalPages,
            goToPage,
            perPage,
            nextPage,
            prevPage,
            truncateText,
            deletePaper,
            isLoading,
            getImageUrl,
            filteredData,
            selectedStatus,
            sortOrder,
            resetFilters,
            filteredCount,
        };
    },
};
</script>
